import CompanyRecord from "../../records/company";
import MerchantRecord from "../../records/merchant";
import OrderRecord from "../../records/order";
import UserRecord from "../../records/user";

export default {
  user: UserRecord,
  order: OrderRecord,
  company: CompanyRecord,
  merchant: MerchantRecord
};